import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { createContext } from "react";

import { LS_TENANT_KEY } from "@/lib/constants";

import useAuthUser from "./useAuthUser";

import type { Dispatch, SetStateAction } from "react";

export type SettingName =
  | "extent_schematic"
  | "extent_topographic"
  | "graph_schematic"
  | "graph_topographic"
  | "moco-default_affected_product_names"
  | "moco-preview_url_dev"
  | "moco-preview_url_prod"
  | "moco-preview_url_stag"
  | "moco-preview_url"
  | "moco-text_templates_sets"
  | "moco-text_templates"
  | "moco-textual_content_languages"
  | "moco-textual_content_sizes"
  | "routing_mot"
  | "slug"
  | "stops_api_bbox"
  | "stops_api_prefagencies"
  | "stops_mots"
  | "style_schematic"
  | "style_topographic"
  | "styles"
  | "tenant"
  | "tralis-line_tags";

export interface Config {
  [key: string]: Record<string, string> | string;
  modified_at: string;
  settings: Record<SettingName, string>;
  slug: string;
  title: string;
}

export interface ConfigContext {
  config?: Config | undefined;
  setConfig: Dispatch<SetStateAction<Config | undefined>>;
}

export const ConfigContext = createContext<ConfigContext>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setConfig: () => {},
} as ConfigContext);

export default function useConfigContext() {
  const context = useContext<ConfigContext>(ConfigContext);
  const router = useRouter();
  const { user } = useAuthUser();

  useEffect(() => {
    // Initialize the config when the user is loaded
    const configs = user?.configs || [];
    const tenant =
      (router.query.tenant as string) || localStorage.getItem(LS_TENANT_KEY);
    const found =
      configs.find((c) => {
        return c.slug === tenant;
      }) ?? configs[0];

    if (found && context.config?.slug !== found.slug) {
      context.setConfig(found);
    }
  }, [context, router.query.tenant, user]);

  return context;
}
